<template>
  <div id="app">
    <nav class="navbar">
      <div class="nav-container">
        <router-link to="/" class="nav-brand" @click.native="closeMenu">
          <img src="~@/assets/img/app_icon.png" alt="MookNote" class="brand-icon" />
          <span class="brand-text">MookNote</span>
        </router-link>
        <ul class="nav-menu" :class="{ active: menuOpen }">
          <li><router-link to="/" exact @click.native="closeMenu">首页</router-link></li>
          <li><router-link to="/features" @click.native="closeMenu">功能特性</router-link></li>
          <li><router-link to="/guide" @click.native="closeMenu">使用指南</router-link></li>
          <li><router-link to="/contact" @click.native="closeMenu">联系我</router-link></li>
        </ul>
        <div class="nav-right">
          <button class="nav-cta" @click="goDownload">下载应用</button>
          <div class="nav-toggle" :class="{ active: menuOpen }" @click="toggleMenu">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </nav>
    <main class="main-content">
      <router-view/>
    </main>
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-grid">
          <div class="footer-col footer-brand-col">
            <div class="footer-brand">
              <img src="~@/assets/img/app_icon.png" alt="MookNote" class="brand-icon" />
              <span>MookNote</span>
            </div>
            <p class="footer-desc">极简风格的观影 · 阅读 · 游戏 · 笔记记录应用。<br>数据本地存储，隐私完全由你掌控。</p>
          </div>
          <div class="footer-col">
            <h4 class="footer-heading">产品</h4>
            <router-link to="/">首页</router-link>
            <router-link to="/features">功能特性</router-link>
            <router-link to="/guide">使用指南</router-link>
            <router-link to="/contact">联系我</router-link>
          </div>
          <div class="footer-col">
            <h4 class="footer-heading">资源</h4>
            <a href="https://github.com/dellevin/mooknote" target="_blank" rel="noopener">GitHub 开源</a>
            <a href="http://docmost.iletter.top/share/ropwljvn/p/mook-note-lHmPTswdDC" target="_blank" rel="noopener">开发记录</a>
            <a href="https://blog.iletter.top" target="_blank" rel="noopener">作者博客</a>
            <a href="https://www.iletter.top/" target="_blank" rel="noopener">作者简介</a>
          </div>
          <div class="footer-col">
            <h4 class="footer-heading">下载</h4>
            <a href="https://mooknote.iletter.top/download/mooknote.apk">Android 版</a>
            <a href="https://mooknote.iletter.top/download/mooknote.rar">Windows 版</a>
            <a href="https://mooknote.iletter.top/download/mooknote-linux.zip">Linux 版</a>
          </div>
        </div>
        <div class="footer-bottom">
          <p>© 2025–2026 MookNote · 基于 AGPL-3.0 协议开源</p>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      menuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
    },
    closeMenu() {
      this.menuOpen = false
    },
    goDownload() {
      this.closeMenu()
      const scroll = () => {
        const el = document.getElementById('download')
        if (el) el.scrollIntoView({ behavior: 'smooth' })
      }
      if (this.$route.path === '/') {
        scroll()
      } else {
        this.$router.push('/').then(() => setTimeout(scroll, 120))
      }
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  --color-bg: #FFFFFF;
  --color-bg-secondary: #FAFAFA;
  --color-bg-tertiary: #F4F4F5;
  --color-text: #1A1A1A;
  --color-text-secondary: #5F5F63;
  --color-text-muted: #9B9BA0;
  --color-border: #ECECED;
  --color-border-strong: #E0E0E2;
  --color-accent: #0066FF;
  --color-accent-soft: rgba(0, 102, 255, 0.08);
  --radius-sm: 10px;
  --radius-md: 16px;
  --radius-lg: 24px;
  --shadow-sm: 0 1px 2px rgba(16, 16, 20, 0.04);
  --shadow-md: 0 4px 16px -4px rgba(16, 16, 20, 0.08), 0 2px 6px -2px rgba(16, 16, 20, 0.04);
  --shadow-lg: 0 20px 48px -16px rgba(16, 16, 20, 0.16), 0 8px 16px -8px rgba(16, 16, 20, 0.06);
  --ease-out: cubic-bezier(0.22, 1, 0.36, 1);
  --font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: var(--font-family);
  color: var(--color-text);
  background-color: var(--color-bg);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
}

::selection {
  background: rgba(0, 102, 255, 0.14);
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* ===== Shared primitives ===== */
.container {
  max-width: 1160px;
  margin: 0 auto;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 13px 28px;
  border-radius: 999px;
  font-size: 15px;
  font-weight: 500;
  font-family: var(--font-family);
  text-decoration: none;
  transition: transform 0.25s var(--ease-out), box-shadow 0.25s var(--ease-out), background 0.25s, border-color 0.25s, color 0.25s;
  cursor: pointer;
  border: 1px solid transparent;
}

.btn-primary {
  background: var(--color-text);
  color: #fff;
  box-shadow: 0 1px 2px rgba(16, 16, 20, 0.2), 0 8px 20px -8px rgba(16, 16, 20, 0.35);
}

.btn-primary:hover {
  background: #000;
  transform: translateY(-2px);
  box-shadow: 0 2px 4px rgba(16, 16, 20, 0.2), 0 14px 28px -8px rgba(16, 16, 20, 0.4);
}

.btn-secondary {
  background: #fff;
  color: var(--color-text);
  border-color: var(--color-border-strong);
}

.btn-secondary:hover {
  border-color: var(--color-text);
  transform: translateY(-2px);
}

.btn-outline {
  background: transparent;
  color: var(--color-text);
  border-color: var(--color-border-strong);
}

.btn-outline:hover {
  border-color: var(--color-text);
  background: var(--color-bg-secondary);
  transform: translateY(-2px);
}

.btn-light {
  background: #fff;
  color: var(--color-text);
}

.btn-light:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px -8px rgba(0, 0, 0, 0.35);
}

.section-eyebrow {
  display: block;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 3px;
  color: var(--color-text-muted);
  margin-bottom: 14px;
}

.section-title {
  font-size: clamp(28px, 4vw, 40px);
  font-weight: 700;
  letter-spacing: -0.5px;
  line-height: 1.2;
  text-align: center;
  margin-bottom: 14px;
  color: var(--color-text);
}

.section-subtitle {
  font-size: 16px;
  color: var(--color-text-secondary);
  text-align: center;
  max-width: 560px;
  margin: 0 auto 56px;
  line-height: 1.8;
}

/* Scroll reveal */
.animate-on-scroll {
  opacity: 0;
  transform: translateY(28px);
  transition: opacity 0.7s var(--ease-out), transform 0.7s var(--ease-out);
}

.animate-on-scroll.is-visible {
  opacity: 1;
  transform: translateY(0);
}

.aos-delay-1 { transition-delay: 0.08s; }
.aos-delay-2 { transition-delay: 0.16s; }
.aos-delay-3 { transition-delay: 0.24s; }
.aos-delay-4 { transition-delay: 0.32s; }

/* ===== Navbar ===== */
.navbar {
  position: fixed;
  top: 14px;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 0 20px;
  pointer-events: none;
}

.nav-container {
  pointer-events: auto;
  max-width: 1080px;
  margin: 0 auto;
  height: 58px;
  padding: 0 8px 0 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(236, 236, 237, 0.9);
  border-radius: 999px;
  box-shadow: 0 1px 3px rgba(16, 16, 20, 0.04), 0 12px 32px -16px rgba(16, 16, 20, 0.12);
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.3px;
  color: var(--color-text);
  text-decoration: none;
}

.brand-icon {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: block;
  box-shadow: var(--shadow-sm);
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 4px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.nav-menu a {
  display: block;
  text-decoration: none;
  color: var(--color-text-secondary);
  font-size: 14.5px;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 999px;
  transition: color 0.2s, background 0.2s;
}

.nav-menu a:hover {
  color: var(--color-text);
  background: var(--color-bg-tertiary);
}

.nav-menu a.router-link-active {
  color: var(--color-text);
  background: var(--color-bg-tertiary);
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-cta {
  padding: 9px 20px;
  border: none;
  border-radius: 999px;
  background: var(--color-text);
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  font-family: var(--font-family);
  cursor: pointer;
  transition: transform 0.25s var(--ease-out), background 0.25s;
}

.nav-cta:hover {
  background: #000;
  transform: translateY(-1px);
}

.nav-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
  padding: 10px;
}

.nav-toggle span {
  width: 20px;
  height: 2px;
  background: var(--color-text);
  transition: all 0.3s var(--ease-out);
  border-radius: 1px;
}

.nav-toggle.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.nav-toggle.active span:nth-child(2) {
  opacity: 0;
}

.nav-toggle.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

/* ===== Main ===== */
.main-content {
  flex: 1;
}

/* ===== Footer ===== */
.footer {
  background: var(--color-bg-secondary);
  border-top: 1px solid var(--color-border);
  padding: 64px 24px 32px;
}

.footer-content {
  max-width: 1160px;
  margin: 0 auto;
}

.footer-grid {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 48px;
  padding-bottom: 48px;
  border-bottom: 1px solid var(--color-border);
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.3px;
  margin-bottom: 16px;
}

.footer-desc {
  color: var(--color-text-secondary);
  font-size: 14px;
  line-height: 1.9;
  max-width: 300px;
}

.footer-heading {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 2px;
  color: var(--color-text-muted);
  margin-bottom: 16px;
}

.footer-col a {
  display: block;
  color: var(--color-text-secondary);
  text-decoration: none;
  font-size: 14px;
  padding: 5px 0;
  transition: color 0.2s, transform 0.2s;
}

.footer-col a:hover {
  color: var(--color-text);
}

.footer-bottom {
  padding-top: 28px;
  text-align: center;
}

.footer-bottom p {
  color: var(--color-text-muted);
  font-size: 13px;
}

/* ===== Responsive ===== */
@media (max-width: 860px) {
  .navbar {
    top: 10px;
    padding: 0 12px;
  }

  .nav-menu {
    position: fixed;
    top: 78px;
    left: 12px;
    right: 12px;
    background: rgba(255, 255, 255, 0.96);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    flex-direction: column;
    padding: 12px;
    gap: 2px;
    border: 1px solid var(--color-border);
    border-radius: 20px;
    box-shadow: var(--shadow-lg);
    transform: translateY(-12px);
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s var(--ease-out);
  }

  .nav-menu.active {
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }

  .nav-menu a {
    padding: 12px 16px;
    font-size: 15px;
  }

  .nav-toggle {
    display: flex;
  }

  .nav-cta {
    display: none;
  }

  .footer-grid {
    grid-template-columns: 1fr 1fr;
    gap: 36px;
  }

  .footer-brand-col {
    grid-column: 1 / -1;
  }

  .animate-on-scroll {
    opacity: 1;
    transform: none;
    transition: none;
  }
}
</style>
